import _ from 'lodash';
import request from '../../../../shared/lib/request';
import { API } from '../../../../shared/constants';

const getOptions = () =>
  new Promise((resolve, reject) => {
    resolve({
      options: [
        { value: 'Franco Franchi', label: 'Franco Franchi' },
        { value: 'Pippo Rossi', label: 'Pippo Rossi' },
      ],
    });
    reject({});
  });


const getAll = () => request(
  {
    url: API.RESPONSABILE_AREA,
    method: 'GET',
  });

const getAllOptions = () => getAll().then(
    (res) => {
      const messyData = res._embedded.responsabile_area.map((obj)=>{ return {value: obj.id, label: _.get(obj, '_embedded.anagrafica.nominativo') || '' }}) // eslint-disable-line
      return _.orderBy(messyData, 'label', 'asc');
    }).then((data) => ({ options: (data) }));

const create = (content) => request(
  {
    url: API.RESPONSABILE_AREA,
    method: 'POST',
    data: content,
  });

const put = (content) => request(
  {
    url: `${API.RESPONSABILE_AREA}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const getById = (id) => request(
  {
    url: `${API.RESPONSABILE_AREA}/${id}`,
    method: 'GET',
  });

const ResponsabileAreaService = {
  getOptions,
  create,
  put,
  getById,
  getAll,
  getAllOptions,
};

export default ResponsabileAreaService;



// WEBPACK FOOTER //
// ./app/shared/services/api/responsabilearea/index.js